import React from 'react';
import { useTranslation } from 'react-i18next';
import { TripStartEnd } from './TripStartEnd';

export const TripStartEndContainer = ({ showOnlyIfAvailable, ...props }) => {
  const { t } = useTranslation();
  return <TripStartEnd t={t} {...props} />;
};
